// 指定されたミリ秒だけ待機する
const wait = (milliseconds: number) => new Promise((resolve) => setTimeout(resolve, milliseconds));

export default wait;
